var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfotip = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 26,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24.84 12.85c0 6.622-5.368 11.99-11.99 11.99S.86 19.472.86 12.85 6.228.86 12.85.86s11.99 5.368 11.99 11.99Z",
  stroke: "url(#infotip_svg__a)",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.64 6.81c0 .93-.71 1.68-1.81 1.68s-1.77-.75-1.75-1.68c-.02-.97.69-1.7 1.77-1.7s1.77.73 1.79 1.7Zm-3.47 13.83V9.82h3.36v10.82h-3.36Z",
  stroke: "url(#infotip_svg__b)",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "infotip_svg__a",
  x1: 0.26,
  y1: 12.85,
  x2: 25.44,
  y2: 12.85,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#071389CC",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#071389CC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "infotip_svg__b",
  x1: 1,
  y1: 13,
  x2: 25,
  y2: 13,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#071389CC",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DFF1FDCC"
})))));
export { SvgInfotip as ReactComponent };
export default __webpack_public_path__ + "/assets/04fba84a1674ca2f74d587fb8711ac8f.svg";